import LegalPageTemplate from "@/components/LegalPageTemplate";
import LegalDocument from "@/components/LegalDocument";
import { useLocale } from "@/lib/locale";

export default function AINoticePage() {
    const { t } = useLocale();
    return (
        <LegalPageTemplate
            docType="ai_notice"
            title={t("legal.ai_notice_title")}
            eyebrow={t("legal.ai_notice_eyebrow")}
            version="2026-02-v1"
        >
            <LegalDocument docKey="ai_notice" />
        </LegalPageTemplate>
    );
}
